import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button } from '@material-ui/core';
import clsx from 'clsx';
// Se cambia RenderTextFieldReduxMin por RenderTextFieldReduxMinRead que es un componente unicamente de lectura
// import RenderTextFieldReduxMin from '../Complements/RenderTextFieldReduxMin';
import RenderTextFieldReduxMinRead from '../Complements/RenderTextFieldReduxMinRead';

import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';

const validate = values => {
    const error  = {}
    
    if (!values.amountdaily) {
        error.amountdaily = "El monto diario es obligatorio."
    }
    if (/^([0-9])*$/.test(values.amountdaily) === false) {
        error.amountdaily = "El campo debe tener solamente números."
    }
    if (!values.amountmonthly) {
        error.amountmonthly = "El monto mensual es obligatorio."
    }
    if (/^([0-9])*$/.test(values.amountmonthly) === false) {
        error.amountmonthly = "El campo debe tener solamente números."
    }
    return error
}

class ChangeQuotasForm extends Component {
    render() {
        const { classes, handleSubmit,  
            // valid, submitting 
        } = this.props;
        return (
            <React.Fragment>
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="amountdaily"
                                id="amountdaily"
                                required
                                allowZero = {true}
                                className={clsx(classes.margin, classes.textField)}
                                component={ RenderTextFieldReduxMinRead }
                                autoComplete="off"
                                label="Monto Diario"
                                type="text"
                                fullWidth
                                disabled
                                readOnly
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="amountmonthly"
                                id="amountmonthly"
                                required
                                allowZero = {true}
                                className={clsx(classes.margin, classes.textField)}
                                autoComplete="off"
                                component={ RenderTextFieldReduxMinRead }
                                label="Monto Mensual"
                                type="text"
                                fullWidth
                                disabled
                                readOnly
                            />
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                // disabled={!valid || submitting}
                                disabled
                                size = { "large" }
                                >
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        );
    }
}

const ChangeQuotasFormRedux = reduxForm(
    {
        form: 'ChangeQuotasForm',
        validate
    }
)(ChangeQuotasForm)

// export default ChangePasswordForm;
export default setPropsAsInitial(ChangeQuotasFormRedux);

